/*
  Nekoki — Sommaire de marge pour les articles Le Carnet.
  Génère le sommaire à partir des <h2> de .content au chargement,
  slugifie les h2 sans id, puis surligne la section courante via
  IntersectionObserver. Fonctionne sur les 12 articles existants
  sans modification de leur HTML.
*/
(function () {
  var content = document.querySelector('.article .content');
  var toc = document.querySelector('.article .toc');
  if (!content || !toc) return;

  var heads = Array.prototype.slice.call(content.querySelectorAll('h2'));
  if (!heads.length) {
    toc.style.display = 'none';
    return;
  }

  function slugify(txt) {
    return String(txt).trim().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  var ol = toc.querySelector('ol');
  if (!ol) {
    ol = document.createElement('ol');
    toc.appendChild(ol);
  }
  ol.innerHTML = '';

  heads.forEach(function (h) {
    if (!h.id) {
      var base = slugify(h.textContent) || 's';
      var id = base;
      var n = 2;
      while (document.getElementById(id)) {
        id = base + '-' + n;
        n += 1;
      }
      h.id = id;
    }
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    ol.appendChild(li);
  });

  var items = Array.prototype.slice.call(ol.querySelectorAll('li'));

  if (!('IntersectionObserver' in window)) return;

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var i = heads.indexOf(e.target);
        items.forEach(function (l) { l.classList.remove('on'); });
        if (items[i]) items[i].classList.add('on');
      }
    });
  }, { rootMargin: '-110px 0px -70% 0px' });

  heads.forEach(function (h) { obs.observe(h); });
})();
